<template>
    <div class="wrapper">
        <div class="wrapper-content">
            <div class="banner">
                <div class="userPanel" @click.stop>
                    <div class="userInfo">
                        <!-- <div class="userPicture" v-show="!isLogin" v-on:click="userLogin()" style="cursor: pointer"><img
                            src="../../assets/images/icon-notLogin.png"
                            width="52px" height="52px"/>
                        </div> -->
                        <div class="userPicture" v-show="!isLogin" v-on:click="userLogin()" style="cursor: pointer">
                            <div class="userPicture-inner">
                                <img src="../../assets/images/icon-notLogin-rect.png" width="67px" height="77px"/>
                            </div>
                        </div>
                        <!-- <div class="userPicture" v-show="isLogin"><img :src="userInfo.avatar" width="52px"
                                                                       height="52px">
                        </div> -->
                        <div class="userPicture" v-show="isLogin">
                            <div class="userPicture-inner">
                                <img :src="userInfo.avatar" width="67px" height="77px" />
                            </div>
                        </div>
                        <div class="userText">
                            <div class="userName" v-show=" isLogin && userInfo.vip_level != 210"
                                 v-text="userInfo.nickname"></div>
                            <div class="userName userName-login" v-show="!isLogin" style=" margin-top: 30px;cursor:pointer"
                                 v-on:click="userLogin()">{{ discount.shouldShow ? 'Sign in for Discount' : 'Sign in' }}
                            </div>
                            <div class="userName-vip" v-show="isLogin && userInfo.vip_level == 210"
                                 v-text="userInfo.nickname"></div>
                            <div class="userNotice" v-show="isLogin && userInfo.vip_level !== 210">You are not WPS
                                Premium
                            </div>
                            <div class="userNotice-vip" v-show="isLogin && userInfo.vip_level == 210"
                                 style="font-family:Cambria;  ">
                                <img class="img-vip" src="../../assets/images/icon-wpsVip.png" alt="loading">
                                <div class="notice-vip">WPS Office Premium</div>
                            </div>
                        </div>
                    </div>
                    <div class="userPrivilege">
                        <div class="PrivilegeTxt" v-show="!isLogin || (isLogin && userInfo.vip_level != 210) "> Upgrate
                            to WPS premium, you will enjoy
                        </div>
                        <div class="PrivilegeTxt" v-show="isLogin && userInfo.vip_level == 210"
                             style="color:#9c9c9c;font-size:12px;">WPS Premium Privileges
                        </div>
                        <div class="iconContainer">
                            <div class="privilegeImgWrapper"><img class="privilegeImg"
                                                                  src="../../assets/images/icon-noAds.png"
                                                                  alt="loading"></div>
                            <div class="privilegeImgWrapper"><img class="privilegeImg"
                                                                  src="../../assets/images/icon-cloud.png"
                                                                  alt="loading"></div>
                            <div class="privilegeImgWrapper"><img class="privilegeImg"
                                                                  src="../../assets/images/icon-pdf-word.png"
                                                                  alt="loading">
                            </div>
                        </div>
                    </div>
                    <div class="userBuy" v-show="!isLogin || (isLogin && userInfo.vip_level != 210)">
                        <div class="product-wrapper">
                            <div id="product-year" productId="12" class="product" v-bind:class="{ selected: productId === 12 }" @click="switchProduct(12)">${{ isUwp ? '29.99' : '29.99' }}/Year</div>
                            <div id="product-months" productId="6" class="product" v-bind:class="{ selected: productId === 6 }" @click="switchProduct(6)">${{ isUwp ? '18.99' : '18.99' }}/6 Months</div>
                        </div>
                        <div class="btn btn-discount" v-show="isLogin" @click="goPremium()">
                            {{ discount.shouldShow ? discount.btntxt : 'GO PREMIUM' }}
                        </div>
                        <div class="btn" v-show="!isLogin" @click="userLogin()">
                            {{ discount.shouldShow ? discount.btntxt : 'GO PREMIUM' }}
                        </div>
                    </div>
                    <div class="userBuy-vip" v-show="isLogin && userInfo.vip_level == 210" style="height: 98px">
                        <div class="userBuy-vipTxt">Thank you for subscribing WPS Premium. <br/> More premium privileges
                            will be coming soon.
                        </div>
                    </div>


                </div>
            </div>
            <div class="details-wrapper">
                <div class="detailsTitle">
                    <div class="titleText">Premium Privileges</div>
                </div>
                <div class="free-title-container">
                    <div class="free-title">Free</div>
                    <div class="free-title">Function</div>
                    <div class="free-title">Privilege</div>
                </div>
                <div class="details">
                    <div class="free">
                        <div class="free-item">
                            <div class="item-icon"><img src="../../assets/images/icon-cloud.png" alt=""></div>
                            <div class="item-text">
                                <div class="item-text-title">20G Free Cloud Storage</div>
                                <div class="item-text-words"> You will get 20G Free<br/> WPS Cloud storage<br/>with WPS
                                    Office<br/> Premium
                                </div>
                            </div>
                        </div>
                        <div class="free-item">
                            <div class="item-icon-bottom"><img src="../../assets/images/icon-pdf-word.png" alt=""></div>
                            <div class="item-text-bottom">
                                <div class="item-text-title">Free PDF to Word conversion</div>
                                <div class="item-text-words">WPS Premium users<br/> can Convert PDF files<br/> to Word documents
                                    <br/> for free (for PC and<br/> android)<br/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="function">
                        <div class="free-item">
                            <div class="item-icon"><img src="../../assets/images/icon-pictoword.png" alt=""></div>
                            <div class="item-text">
                                <div class="item-text-title">Picture to Text</div>
                                <!-- <div class="item-text-words"> You will get 20G Free<br/> WPS Cloud storage<br/>with WPS
                                    Office<br/> Premium
                                </div> -->
                                <div class="item-text-words"> Powerful engine<br/> could recognize words<br/> in you picture and<br/> export as text.
                                </div>
                            </div>
                        </div>
                        <div class="free-item">
                            <div class="item-icon-bottom"><img src="../../assets/images/icon-docs.png" alt=""></div>
                            <div class="item-text-bottom">
                                <div class="item-text-title">Save Docs as pics</div>
                                <div class="item-text-words">WPS Premium users <br/> can export their <br/>
                                    documents as pictures <br/> watermark
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="privilege">
                        <div class="free-item">
                            <div class="item-icon"><img src="../../assets/images/icon-noAds.png" alt=""></div>
                            <div class="item-text">
                                <div class="item-text-title">No Ads</div>
                                <div class="item-text-words"> WPS office Premium<br/>is clear and efficient<br/>No ADs
                                    on
                                    all
                                    your <br/>devices
                                </div>
                            </div>
                        </div>
                        <div class="free-item">
                            <div class="item-icon-bottom"><img src="../../assets/images/icon-support9devices.png" alt=""></div>
                            <div class="item-text-bottom">
                                <div class="item-text-title">Multiple Devices </div>
                                <div class="item-text-words">WPS Premium support<br/>up to 9 connected<br/>devices
                                    (3PCs,<br/> 6Mobiles).
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Util from '../../assets/js/util.js';

    export default {
        data: () => ({
            userInfo: {},
            productId: 12
        }),
        mounted() {
            Util.gaReport('send', 'event', '/vipIntroduce', 'show');
        },
        props: {
            isLogin: {
                type: Boolean,
                default: false
            },
            discount: {
                type: Object
            },
        },
        watch: {
            isLogin(data) {
                if (data) {
                    this.getUserInfo();
                } else {
                    this.userInfo = {};
                    //清除cookie
                    Util.Cookie.create('wps_sid', null, -10000000, '.wps.com');
                    Util.Cookie.create('wps_vip', null, -10000000, '.wps.com');

                    // VEvts.$emit('VIP_STATUS_CHANGE');
                }
            }
        },

        computed: {
            isUwp() {
                return this.$store.state.uwp;
            }
        },

        methods: {


            //根据不同产品跳转不同支付页面
            goPremium() {
                let productId = this.productId;
                let showDiscount = this.discount.shouldShow;
                let ga_type = showDiscount ? 'signinDiscount/btn' : '/vipIntroduce/buyProduct';
                if (productId === 6) {
                    Util.popupPayment('premium&feature=docer&price_option=subs_6months')
                        .then(() => {})
                        .catch(err => {
                            Util.goAvengateCart({
                                productId: 7,
                                couponCode: showDiscount ? this.discount.couponCode : '',
                                source: showDiscount ? 'WPS_SUBS_V6_Docer2Vip_Signin_Discount_Btn' : 'WPS_SUBS_V6_Docer2Vip',
                            });
                        });
                    Util.gaReport('send', 'event', ga_type, 'click', '6 months');

                } else if (productId === 12) {
                    Util.popupPayment('premium&feature=docer&price_option=subs_12months')
                        .then(() => {})
                        .catch(err => {
                            Util.goAvengateCart({
                                productId: 8,
                                couponCode: showDiscount ? this.discount.couponCode : '',
                                source: showDiscount ? 'WPS_SUBS_V12_Docer2Vip_Signin_Discount_Btn' : 'WPS_SUBS_V12_Docer2Vip',
                            });
                        });
                    Util.gaReport('send', 'event', ga_type, 'click', '12 months');
                }
            },
            //获取用户信息
            getUserInfo() {
                let _this = this,
                    param = {
                        'http_method': 'POST',
                        'urlbase': 'https://cloud.wps.com',
                        'urlapi': '/api/v2/auth/check',
                        'contentType': 'application/json'
                    };

                param.data = JSON.stringify({'info': 1, 'csrfmiddlewaretoken': 'docer'});
                Util.jsAsynCall('doAuthHttpRequest', param, true)
                    .then(function (res) {
                        const data = res.response_data.user || {};
                        _this.userInfo = {
                            avatar: data.pic,
                            userid: data.userid,
                            nickname: data.nickname,
                            wps_sid: data.wps_sid,
                            accessid: data.accessid,
                            vip_level: data.vip_level || 10
                        };

                        Util.Cookie.create('wps_sid', data.wps_sid, undefined, '.wps.com');

                        if (data.vip_level == 210) {
                            Util.Cookie.create('wps_vip', 1, undefined, '.wps.com');
                        } else {
                            Util.Cookie.create('wps_vip', 0, undefined, '.wps.com');
                        }

                        // VEvts.$emit('VIP_STATUS_CHANGE');
                    })
                    .catch(function () {
                        _this.userInfo = {};
                    });
            },
            qingOpenUrl(url) {
                return Util.jsAsynCall('qingOpenVipUrl', {'callbackurl': url});
            },

            userLogin() {
                Util.jsAsynCall('qingLogin');
                Util.gaReport('send', 'event', '/vipIntroduce/userLogin', 'click');
            },

            // 切换产品
            switchProduct(id) {
                this.productId = id;
                Util.gaReport('send', 'event', '/vipIntroduce/chooseProduct', 'click');
            },
        }
    }
</script>


<style scoped>
    .wrapper{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #F7F7F7;
        overflow-y: scroll;
        box-sizing: border-box;
    }
    .wrapper-content {
        font-family: "Microsoft YaHei";
        width: 94%;
        margin-left: 3%;
        margin-right: 3%;
        margin-top: 25px;
        background-color: #ffffff;
        position: absolute;
    }

    .banner {
        height: 372px;
        width: 100%;
        background-image: url("../../assets/images/banner.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-color: #f43543;
    }

    .details-wrapper {
        width: 85%;
        margin-top: 44px;
        margin-left: 126px;
    }

    .detailsTitle {
        font-size: 22px;
        color: #fc944e;
        height: 22px;
        border-left: 4px solid #fc944e;
    }

    .titleText {
        margin-left: 10px;
        font-weight: 600;
        float: left;
        margin-top: 2px;
    }

    .details {
        width: 100%;
        height: 380px;
        margin-top: -15px;
        padding-bottom: 65px;
    }

    .free {
        float:left;
        height: 100%;
        background-color: #f7fff6;
        width: 33.33%;
    }

    .function {
        float:left;
        height: 100%;
        width: 33.33%;
        background-color: #f7fbff;
    }

    .privilege {
        float:left;
        height: 100%;
        width: 33.33%;
        background-color: #fefdf4;
    }

    .free-item {
        text-align: center;
        width: 100%;
        height: 50%;
    }

    .item-icon {
        width:50%;
        margin-top: 10%;
        float: left;
    }

    .item-text {
        width: 50%;
        margin-top: 10%;
        text-align: left;
        float: left;
    }

    .item-icon-bottom{
        width:50%;
        margin-top: 5%;
        float: left;
    }
    .item-text-bottom{
        width:50%;
        margin-top: 5%;
        text-align: left;
        float: left;
    }

    .item-text-title {
        font-size: 16px;
        color: #575759;
        margin-bottom: 10px;
        font-weight: bold;
    }

    .item-text-words {
        font-size: 12px;
        color: #92969A
    }

    .free-title-container {
        width: 100%;
        margin-top: 35px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        font-size: 18px;
        color: white;
        position: relative;
    }

    .free-title {
        background-image: url("../../assets/images/little-icon.png");
        background-repeat: no-repeat;
        background-position: center;
        width: 33.33%;
        float: left;
    }

    .userPanel {
        cursor: auto;
        position: absolute;
        width: 303px;
        height: 300px;
        background-color: rgba(255,255,255,0.7);
        right: 7%;
        top: 42px;
    }

    .userInfo {
        display: inline-block;
        height: 72px;
        width: 100%;
    }

    .userPicture {
        width: 67px;
        height: 77px;
        border-radius: 0px;
        overflow: hidden;
        margin: 15px 15px;
        float: left;
        transform: rotate(-60deg) skewY(30deg) translatez(-1px);
        -webkit-transform: rotate(-60deg) skewY(30deg) translatez(-1px);
        position: absolute;
        top: -40px;
        left: -38px;
    }

    .userPicture-inner {
        display: block;
        width: 100%;
        height: 100%;
        transform: skewY(-30deg) rotate(60deg);
        -webkit-transform: skewY(-30deg) rotate(60deg);
    }

    .userText {
        display: inline-block;
        width: 215px;
        height: 100%;
        float: left;
        margin-left: 65px;
    }

    .userName {
        width: 100%;
        height: 22px;
        font-size: 16px;
        color: #221E1F;
        font-weight: 600;
        line-height: 22px;
        margin-left: 11px;
        margin-top: 14px
    }

    .userName-login {
        width: 190px;
        height: 35px;
        line-height: 35px;
        text-align: center;
        background-color: #5fb0f4;
        background: linear-gradient(to bottom, #73bbee, #47a2fa);
        color: #fff;
        font-size: 14.5px;
        font-weight: 500;
        border-radius: 4px;
        position: relative;
        top: -4px;
        margin-left: 0;
        font-family: Arial;
    }

    .userName-login:hover {
        opacity: 0.9;
    }

    .userName-vip {
        width: 100%;
        height: 22px;
        font-size: 16px;
        color: #221E1F;
        font-weight: 600;
        line-height: 22px;
        margin-top: 14px
    }

    .userNotice {
        background-color: #b4b9b9;
        width: 80%;
        height: 21px;
        color: white;
        font-size: 12px;
        text-align: center;
        line-height: 21px;
        margin-top: 10px;
    }

    .userNotice-vip {
        width: 80%;
        height: 21px;
        color: #575a59;
        font-size: 12px;
        text-align: center;
        line-height: 21px;
        margin-top: 9px;
        margin-bottom: 23px;
    }

    .img-vip {
        float: left;
    }

    .notice-vip {
        float: left;
        margin-left: 5px;
    }

    .userPrivilege {
        width: 100%;
        height: 116px;
        background-color: rgba(255, 255, 255, 0.8);
    }

    .PrivilegeTxt {
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-size: 12px;
        color: #414141;
    }

    .iconContainer {
        width: 100%;
        height: 76px;
        text-align: center;
    }

    .privilegeImgWrapper {
        width: 26%;
        text-align: center;
        display: inline-block;
    }

    .privilegeImg {
        margin: auto;
        width: 60px;
        height: 65px;
    }

    .userBuy {
        width: 100%;
        height: 122px;
    }

    .userBuy-vip {
        width: 100%;
        height: 98px;
        text-align: center;
    }

    .userBuy-vipTxt {
        margin-top: 35px;
        font-size: 12px;
        color: #938B86
    }

    .product-wrapper {
        width: 80%;
        height: 30px;
        text-align: center;
        margin-top: 10px;
        margin-left: 31px;
    }

    #product-year {
        width: 47%;
        height: 30px;
        float: left;
        line-height: 30px;
        font-size: 12px;
        cursor: pointer;
        border: 2px solid #A5A2A4;
        user-select: none;
        border-radius: 3px 0 0 3px;
    }

    #product-months {
        width: 50%;
        height: 30px;
        float: left;
        line-height: 30px;
        font-size: 12px;
        cursor: pointer;
        border: 2px solid #A5A2A4;
        border-left: 2px solid #44a1fb;
        user-select: none;
        margin-left: -2px;
        border-radius: 0 3px 3px 0;
    }

    .btn {
        width: 80%;
        height: 30px;
        color: white;
        margin-left: 31px;
        margin-bottom: 30px;
        text-align: center;
        line-height: 30px;
        margin-top: 17px;
        cursor: pointer;
        user-select: none;
        border: 1px solid transparent;
        background-color: #5fb0f4;
        background: linear-gradient(to bottom, #73bbee, #47a2fa);
        border-radius: 5px;

    }

    .selected {
        border: 2px solid #44a1fb !important;
    }
</style>



// WEBPACK FOOTER //
// VipIntroduce.vue?2c7a3f99